import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditServiceLayer from "../../components/service-catalog/EditServiceLayer";

const EditServicePage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Edit Service" />
        <EditServiceLayer />
      </MasterLayout>
    </>
  );
};

export default EditServicePage;
